import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/direct-mail-GLYT-update/direct-mail-glyt-2023.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};